import React, { useEffect, useState } from 'react';
import './NewsTodo.css';
import './HomeAdmin.css';
import AdminNavbar from './AdminNavbar';

const API_URL = 'https://backend-zonamicroondas.vercel.app/api/news';
const PAGE_SIZE = 5; // <-- ahora mostramos 5 noticias por página

export default function NewsTodo() {
  /* ====== DATOS ====== */
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [page, setPage] = useState(0);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(API_URL);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const payload = await res.json();
      if (!payload || !payload.success) throw new Error('Respuesta inválida de la API');

      const items = Array.isArray(payload.data) ? payload.data.slice() : [];
      items.sort((a, b) => {
        const da = new Date(a.published_at || a.created_at || 0).getTime();
        const db = new Date(b.published_at || b.created_at || 0).getTime();
        return db - da;
      });

      setNews(items);
      setPage(0);
    } catch (err) {
      setError(err.message || 'Error al cargar noticias');
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(1, Math.ceil(news.length / PAGE_SIZE));
  const start = page * PAGE_SIZE;
  const pageItems = news.slice(start, start + PAGE_SIZE);

  const handlePrev = () => setPage(p => Math.max(0, p - 1));
  const handleNext = () => setPage(p => Math.min(totalPages - 1, p + 1));


  /* ====== ELIMINAR ====== */
  const handleDelete = async (newsId) => {
    const ok = window.confirm('¿Eliminar esta noticia? Esta acción no se puede deshacer.');
    if (!ok) return;

    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const res = await fetch(`${API_URL}/${newsId}`, { method: 'DELETE' });
      const data = await res.json().catch(() => null);
      if (!res.ok || !data || !data.success) {
        throw new Error(data?.error || `Error al eliminar: ${res.status}`);
      }

      // Quitar de la UI sin recargar todo
      setNews(prev => {
        const next = prev.filter(n => n.id !== newsId);
        // ajustar página si quedó vacía
        const newTotalPages = Math.max(1, Math.ceil(next.length / PAGE_SIZE));
        setPage(p => Math.min(p, newTotalPages - 1));
        return next;
      });

      setSuccess('Noticia eliminada correctamente');
    } catch (err) {
      setError(err.message || 'Error al eliminar noticia');
    } finally {
      setLoading(false);
      // limpiar success luego de 2.5s
      setTimeout(() => setSuccess(null), 2500);
    }
  };

  return (
    <div className="home-container">
      <AdminNavbar />

      {/* Contenido principal */}
      <main className="main-content">
        <div className="news-todo-container">
          <h2 className="news-todo-title">Noticias</h2>

          {loading && <div className="loading">Cargando noticias...</div>}
          {error && <div className="error">{error}</div>}
          {success && <div className="success-message" style={{ marginBottom: 12 }}>{success}</div>}

          {!loading && !error && (
            <>
              {pageItems.length === 0 ? (
                <div className="no-data">No hay noticias disponibles.</div>
              ) : (
                <ul className="news-list">
                  {pageItems.map((item) => (
                    <li key={item.id} className="news-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px' }}>
                      <span className="news-title" style={{ margin: 0, fontSize: '0.97rem' }}>{item.title || 'Sin título'}</span>
                      <button
                        type="button"
                        onClick={() => handleDelete(item.id)}
                        className="btn-delete"
                        disabled={loading}
                        aria-label={`Eliminar noticia ${item.id}`}
                        style={{ flexShrink: 0, marginLeft: 16 }}
                      >
                        Eliminar
                      </button>
                    </li>
                  ))}
                </ul>
              )}

              {/* PAGINADOR */}
              {news.length > PAGE_SIZE && (
                <div className="pagination" style={{
                  marginTop: 20,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 12
                }}>
                  <button
                    className="page-btn"
                    onClick={handlePrev}
                    disabled={page === 0}
                    aria-label="Anterior"
                  >
                    &lt;
                  </button>

                  <div className="page-info" aria-live="polite" style={{ minWidth: 160, textAlign: 'center' }}>
                    Noticias {page + 1} de {totalPages}
                  </div>

                  <button
                    className="page-btn"
                    onClick={handleNext}
                    disabled={page >= totalPages - 1}
                    aria-label="Siguiente"
                  >
                    &gt;
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-links">
          <a href="#privacidad">Política de Privacidad</a>
          <a href="#terminos">Términos y Condiciones</a>
          <a href="#contacto">Contacto</a>
        </div>
        <p className="footer-text">© 2025 Panel de Administrador. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}
